import { useFavoritoContext } from 'Context/Favoritos';
import styles from './Card.module.css'
import iconeFavoritar from './favoritar.png'
import iconeDesFavoritar from './desfavoritar.png'
import { Link } from 'react-router-dom';

function Card({ id, titulo, capa}) {
    const { favorito, adicionarFavorito } = useFavoritoContext();
    const ehFavorito = favorito.some(fav => fav.id === id);
    const icone = !ehFavorito ? iconeFavoritar : iconeDesFavoritar

    return (
<div className={styles.container}>
    <Link className={styles.link} to={`/${id}`}>

    <img src={capa} alt={titulo} className={styles.capa}></img>
    <h2>{titulo}</h2>
    </Link>

    <img src={icone}
    alt="filme favorito"
    className={styles.favoritar}
    onClick={() => {
        adicionarFavorito({ id, titulo, capa})
    }} />
</div>
    )
}

export default Card;